<template>
  <div id="deliveryConfirm">
    <dd-header
      :headerSubContentType=1
      :headerTelContentType=1
    />
    <div id="container">
      <dd-sitemap
        :pageKey="pageKey"
        :pageList="topForm.pageList"
      />
      <div id="content">
        <div class="title">
          <h2>事前現場調査内容確認画面</h2>
        </div>
        <section id="researchPlace">
          <label class="text_size_big bold">調査依頼場所</label>
          <div class="input_list">
            <ul>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>郵便番号：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{values.postcd}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>住所：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{values.state}} {{values.city}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big"></div>
                <div>
                  <label class="text_size_middle bold">{{values.street}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>調査物件名：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{values.building}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>立会人氏名：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{values.userLastName}}{{values.userFirstName}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>立会人氏名(カナ)：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{values.userLastNameKana}}{{values.userFirstNameKana}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>立会人電話番号：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{values.tel}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>立会人への直接連絡：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{values.contactFlag}}</label>
                </div>
              </li>
            </ul>
          </div>
        </section>
        <section id="resrchCost">
          <label class="text_size_big bold">お見積り金額</label>
          <div class="input_list">
            <ul>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>事前調査費用：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{formatPrice(values.price)}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>消費税：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{formatPrice(values.tax)}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>合計：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{formatPrice(values.totalPrice)}}</label>
                </div>
              </li>
            </ul>
          </div>
        </section>
        <section id="resrchInfo">
          <label class="text_size_big bold">事前調査内容</label>
          <div class="input_list check_list">
            <ul>
              <li>
                <div class="item_title_big">
                  <label>1.専有部分</label>
                </div>
                <ul class="list_layer_top">
                  <li class="list_layer">
                    <div >
                      <label>設置場所の採寸</label>
                    </div>
                    <div>
                      <label >：{{values.priPosition}}</label>
                    </div>
                  </li>
                  <li class="list_layer">
                    <div >
                      <label>設置場所の下地確認</label>
                    </div>
                    <div>
                      <label >：{{values.priGround}}</label>
                    </div>
                  </li>
                  <li class="list_layer">
                    <div >
                      <label>コンセント・PS等壁設置物確認</label>
                    </div>
                    <div>
                      <label >：{{values.priPlug}}</label>
                    </div>
                  </li>
                  <li class="list_layer">
                    <div >
                      <label>照明・自火報等天井設置物確認</label>
                    </div>
                    <div>
                    <label  >：{{values.priCeiling}}</label>
                    </div>
                  </li>
                  <li class="list_layer">
                    <div >
                      <label>搬入経路の有効寸法確認</label>
                    </div>
                    <div>
                      <label  >：{{values.priCarryRoute}}</label>
                    </div>
                  </li>
                  <li class="list_layer">
                    <div >
                      <label>その他確認事項</label>
                    </div>
                    <div class="word_wrap">
                      <label >：{{values.priConfComment}}</label>
                    </div>
                  </li>
                </ul>
              </li>
              <li>
                <div class="item_title_big">
                  <label>2.共有部分</label>
                </div>
                <ul class="list_layer_top">
                  <li class="list_layer">
                    <div >
                      <label>トラック停車位置</label>
                    </div>
                    <div>
                      <label >：{{values.pubTruckPark}}</label>
                    </div>
                  </li>
                  <li class="list_layer">
                    <div >
                      <label>搬入経路</label>
                    </div>
                    <div>
                      <label >：{{values.pubCarryRoute}}</label>
                    </div>
                  </li>
                  <li class="list_layer">
                    <div >
                      <label>エレベーターサイズ</label>
                    </div>
                    <div>
                      <label  >：{{values.pubElevator}}</label>
                    </div>
                  </li>
                  <li class="list_layer">
                    <div >
                      <label>搬入施工時の事前申請</label>
                    </div>
                    <div>
                      <label >：{{values.pubRequest}}</label>
                    </div>
                  </li>
                  <li class="list_layer">
                    <div >
                      <label>共有部養生の有無</label>
                    </div>
                    <div>
                      <label >：{{values.pubCuring}}</label>
                    </div>
                  </li>
                  <li class="list_layer">
                    <div >
                      <label>駐車場の有無</label>
                    </div>
                    <div>
                      <label >：{{values.pubParking}}</label>
                    </div>
                  </li>
                  <li class="list_layer">
                    <div >
                      <label>その他確認事項</label>
                    </div>
                    <div class="word_wrap">
                      <label >：{{values.pubConfComment}}</label>
                    </div>
                  </li>
                </ul>
              </li>
              <!--
              <li>
                <div class="item_title_big">
                  <label>3.添付画像</label>
                </div>
                <ul>
                  <li class="list_layer">
                    <div>
                      <label>添付画像名</label>
                    </div>
                    <div>
                      <label>：{{values.imgName}}</label>
                    </div>
                  </li>
                  <li class="list_layer">
                    <div class="word_wrap">
                      <label>添付画像コメント</label>
                    </div>
                    <div>
                      <label>：{{values.attchImgComment}}</label>
                    </div>
                  </li>
                </ul>
              </li>
              -->
              <li>
                <div class="item_title_big">
                  <label>3.その他コメント</label>
                </div>
                <ul>
                  <li class="list_layer word_wrap">
                      <label>{{values.otherComment}}</label>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </section>
        <section id="resrchDays">
          <label class="text_size_big bold">事前調査希望日</label>
          <div class="input_list check_list">
            <ul>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>第一希望日：</label>
                </div>
                <div>
                <label class="text_size_middle bold">{{values.pref1Val}} {{values.pref1TimeVal}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>第二希望日：</label>
                </div>
                <div>
                <label class="text_size_middle bold">{{values.pref2Val}} {{values.pref2TimeVal}}</label>
                </div>
              </li>
            </ul>
            <ul>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>その他日程調整希望：</label>
                </div>
                <div class="word_wrap">
                <label class="text_size_middle bold">{{values.scheduleComment}}</label>
                </div>
              </li>
            </ul>
            <ul>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>依頼人の立ち合い：</label>
                </div>
                <div>
                  <label class="text_size_middle bold">{{values.observer}}</label>
                </div>
              </li>
              <li class="list_line2_center">
                <div class="item_title_big">
                  <label>調査先への入室方法：</label>
                </div>
                <div class="word_wrap">
                  <label class="text_size_middle bold">{{values.entranceComment}}</label>
                </div>
              </li>
            </ul>
          </div>
        </section>
        <section id="pre_confirm">
          <label class="text_size_big bold">確認事項</label>
          <div class="input_list">
            <div class="check_box">
              <label>
                <input type="checkbox" v-model="confirmPlace"/>
                調査依頼の場所に間違いありません
              </label>
            </div>
            <div class="check_box">
              <label>
                <input type="checkbox" v-model="confirmPrice"/>
                お見積金額を確認しました
              </label>
            </div>
            <div class="check_box">
              <label>
                <input type="checkbox" v-model="confirmContent"/>
                調査依頼内容に間違いありません
              </label>
            </div>
            <div class="check_box">
              <label>
                <input type="checkbox" v-model="confirmPreferredDate"/>
                調査依頼の希望日に間違いありません
              </label>
            </div>
          </div>
        </section>
        <section id="form_button">
          <div id="regist_btn">
            <button type="submit" class="main_btn cancel_btn" @click="goBack()">戻る</button>
            <button type="submit" class="main_btn" :disabled="isOrderDisable" @click="confirm()">注文する</button>
          </div>
        </section>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'

// import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import * as FormUtil from '../../utils/FormUtil'
// Module
import Header from '../components/common/DcHeader'
import SiteMap from '../components/common/SiteMap'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  name: 'BuildingResearchConfirm',
  components: {
    'dd-header': Header,
    'dd-sitemap': SiteMap,
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      pageKey: 'orderConfirm',
      topForm: {},
      priceData: {},
      resrchData: {},
      inputData: {},
      fileName: '',
      values: {
        postcd: 0,
        state: '',
        city: '',
        street: '',
        building: '',
        userFirstName: '',
        userLastName: '',
        userFirstNameKana: '',
        userLastNameKana: '',
        tel: 0,
        contactFlag: '',
        price: 0,
        tax: 0,
        totalPrice: 0,
        priPosition: '',
        priGround: '',
        priPlug: '',
        priCeiling: '',
        priCarryRoute: '',
        priConfComment: '',
        pubTruckPark: '',
        pubCarryRoute: '',
        pubElevator: '',
        pubRequest: '',
        pubCuring: '',
        pubParking: '',
        pubConfComment: '',
        // 画像添付一旦廃止
        // attchImgComment: '',
        // imgName: '',
        otherComment: '',
        allDaysFlg: false,
        scheduleComment: '',
        pref1Val: '',
        pref2Val: '',
        pref1TimeVal: '',
        pref2TimeVal: '',
        observer: 0,
        entranceComment: ''
      },
      form: {
        resrchId: '',
        corpId: '',
        userId: '',
        resrchPostcd: '',
        resrchState: '',
        resrchCity: '',
        resrchStreet: '',
        resrchBuilding: '',
        resrchUserFirstName: '',
        resrchUserLastName: '',
        resrchUserFirstNameKana: '',
        resrchUserLastNameKana: '',
        resrchTel: '',
        contactFlag: 0,
        // 以下事前現場調査入力
        resrchPriPositionFlg: false,
        resrchPriGroundFlg: false,
        resrchPriPlugFlg: false,
        resrchPriCeilingFlg: false,
        resrchPriCarryRouteFlg: false,
        resrchPriConfComment: '',
        resrchPubTruckParkFlg: false,
        resrchPubCarryRouteFlg: false,
        resrchPubElevatorFlg: false,
        resrchPubRequestFlg: false,
        resrchPubCuringFlg: false,
        resrchPubParkingFlg: false,
        resrchPubConfComment: '',
        resrchAttchImgComment: '',
        resrchOtherComment: '',
        resrchPref1: '',
        resrchPref1Type: 0,
        resrchPref2: '',
        resrchPref2Type: 0,
        resrchAllDaysFlg: false,
        resrchScheduleComment: '',
        resrchObserver: 0,
        resrchEntranceComment: ''
      },
      messages: {},
      confirmPlace: false,
      confirmPrice: false,
      confirmContent: false,
      confirmPreferredDate: false
    }
  },
  computed: {
    isOrderDisable: function () {
      if (this.confirmPlace && this.confirmPrice &&
          this.confirmContent && this.confirmPreferredDate) {
        return false
      }
      return true
    }
  },
  methods: {
    goBack: function () {
      this.$router.go(-1)
    },
    fetchData: function () {
      this.fileName = App.getLocalStorage(DC_STORAGE_KEY.FILE_NAME)
      this.priceData = App.getLocalStorage(DC_STORAGE_KEY.PRICE_DATA)
      this.topForm = App.getLocalStorage(DC_STORAGE_KEY.TOP_FORM)
      this.resrchData = App.getLocalStorage(DC_STORAGE_KEY.RESEARCH_DATA)
      this.inputData = App.getLocalStorage(DC_STORAGE_KEY.PREF_RESEARCH)
      // if (!this.topForm.colorCounter) {
      //   let colorCounter = {
      //     colorCounter: {id: '', name: null}
      //   }
      //   this.topForm = Object.assign(this.topForm, colorCounter)
      // }
      this.values = {
        // 住所
        postcd: this.resrchData.resrchPostcd,
        state: this.resrchData.resrchState,
        city: this.resrchData.resrchCity,
        street: this.resrchData.resrchStreet,
        building: this.resrchData.resrchBuilding,
        userFirstName: this.resrchData.resrchUserFirstName,
        userLastName: this.resrchData.resrchUserLastName,
        userFirstNameKana: this.resrchData.resrchUserFirstNameKana,
        userLastNameKana: this.resrchData.resrchUserLastNameKana,
        tel: this.resrchData.resrchTel,
        contactFlag: (this.resrchData.contactFlag === 1) ? 'あり' : 'なし',
        // 金額
        price: this.priceData.resrchPrice,
        tax: this.priceData.resrchPriceTax,
        totalPrice: this.priceData.resrchTotalPrice,
        // 専有部分
        priPosition: this.inputData.resrchPriPositionFlg ? 'あり' : 'なし',
        priGround: this.inputData.resrchPriGroundFlg ? 'あり' : 'なし',
        priPlug: this.inputData.resrchPriPlugFlg ? 'あり' : 'なし',
        priCeiling: this.inputData.resrchPriCeilingFlg ? 'あり' : 'なし',
        priCarryRoute: this.inputData.resrchPriCarryRouteFlg ? 'あり' : 'なし',
        priConfComment: this.inputData.resrchPriConfComment,
        // 共有部分
        pubTruckPark: this.inputData.resrchPubTruckParkFlg ? 'あり' : 'なし',
        pubCarryRoute: this.inputData.resrchPubCarryRouteFlg ? 'あり' : 'なし',
        pubElevator: this.inputData.resrchPubElevatorFlg ? 'あり' : 'なし',
        pubRequest: this.inputData.resrchPubRequestFlg ? 'あり' : 'なし',
        pubCuring: this.inputData.resrchPubCuringFlg ? 'あり' : 'なし',
        pubParking: this.inputData.resrchPubParkingFlg ? 'あり' : 'なし',
        pubConfComment: this.inputData.resrchPubConfComment,
        // その他コメントやフラグ
        otherComment: this.inputData.resrchOtherComment,
        allDaysFlg: this.inputData.resrchAllDaysFlg,
        // 画像添付一旦廃止
        // attchImgComment: this.inputData.resrchAttchImgComment,
        // imgName: (this.inputData.imgName === '選択されていません') ? '' : this.inputData.imgName,
        scheduleComment: this.inputData.resrchScheduleComment,
        observer: (this.inputData.resrchObserver === 1) ? 'あり' : 'なし',
        entranceComment: this.inputData.resrchEntranceComment
      }
    },
    getViewDate: function () {
      // 表示用フォーマット変数
      this.values.pref1Val = FormUtil.getViewDate(this.inputData.resrchPref1)
      this.values.pref2Val = FormUtil.getViewDate(this.inputData.resrchPref2)
    },
    getViewTime: function () {
      this.form.resrchPref1Type = this.inputData.resrchPref1Type
      switch (this.form.resrchPref1Type) {
        case 1:
          this.values.pref1TimeVal = 'AM( 9:00 ～ 13:00)'
          break
        case 2:
          this.values.pref1TimeVal = 'PM(13:00 ～ 17:00)'
          break
        default:
          this.values.pref1TimeVal = '指定なし'
          break
      }
      this.form.resrchPref2Type = this.inputData.resrchPref2Type
      switch (this.form.resrchPref2Type) {
        case 1:
          this.values.pref2TimeVal = 'AM( 9:00 ～ 13:00)'
          break
        case 2:
          this.values.pref2TimeVal = 'PM(13:00 ～ 17:00)'
          break
        default:
          this.values.pref2TimeVal = '指定なし'
          break
      }
    },
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return '￥' + ret
    },
    confirm: function () {
      this.$refs.loadingModalRef.showModal(true)

      let payload = {
        // 現調入力
        businessName: this.resrchData.resrchBusinessName,
        postcd: this.resrchData.resrchPostcd,
        state: this.resrchData.resrchState,
        city: this.resrchData.resrchCity,
        street: this.resrchData.resrchStreet,
        building: this.resrchData.resrchBuilding,
        userFirstName: this.resrchData.resrchUserFirstName,
        userLastName: this.resrchData.resrchUserLastName,
        userFirstNameKana: this.resrchData.resrchUserFirstNameKana,
        userLastNameKana: this.resrchData.resrchUserLastNameKana,
        tel: this.resrchData.resrchTel,
        contactFlag: this.resrchData.contactFlag,
        // 事前現場調査項目
        resrchPriPositionFlg: this.inputData.resrchPriPositionFlg,
        resrchPriGroundFlg: this.inputData.resrchPriGroundFlg,
        resrchPriPlugFlg: this.inputData.resrchPriPlugFlg,
        resrchPriCeilingFlg: this.inputData.resrchPriCeilingFlg,
        resrchPriCarryRouteFlg: this.inputData.resrchPriCarryRouteFlg,
        resrchPriConfComment: this.inputData.resrchPriConfComment,
        resrchPubTruckParkFlg: this.inputData.resrchPubTruckParkFlg,
        resrchPubCarryRouteFlg: this.inputData.resrchPubCarryRouteFlg,
        resrchPubElevatorFlg: this.inputData.resrchPubElevatorFlg,
        resrchPubRequestFlg: this.inputData.resrchPubRequestFlg,
        resrchPubCuringFlg: this.inputData.resrchPubCuringFlg,
        resrchPubParkingFlg: this.inputData.resrchPubParkingFlg,
        resrchPubConfComment: this.inputData.resrchPubConfComment,
        // 画像添付一旦廃止コメント化
        // resrchAttchImgComment: this.inputData.resrchAttchImgComment,
        resrchOtherComment: this.inputData.resrchOtherComment,
        resrchPref1: this.inputData.resrchPref1,
        resrchPref1Type: this.inputData.resrchPref1Type,
        resrchPref2: this.inputData.resrchPref2,
        resrchPref2Type: this.inputData.resrchPref2Type,
        resrchScheduleComment: this.inputData.resrchScheduleComment,
        resrchObserver: (this.inputData.resrchObserver === 1),
        resrchEntranceComment: this.inputData.resrchEntranceComment,
        // 商品情報
        productName: this.fileName,
        colorDoorId: this.topForm.colorDoor ? this.topForm.colorDoor.id : null,
        colorBoxId: this.topForm.colorCabine ? this.topForm.colorCabine.id : null,
        colorCenterId: this.topForm.colorCounter ? this.topForm.colorCounter.id : null,
        width: this.topForm.topSpace.dcWidth,
        height: this.topForm.topSpace.dcHeight,
        depth: this.topForm.topSpace.dcDepth,
        fillerLeft: this.topForm.topSpace.dcBSize,
        fillerRight: this.topForm.topSpace.dcCSize,
        fillerCenter: this.topForm.topSpace.dcDSize,
        shelfCount: this.topForm.dcShelfCount,
        fillerCount: this.topForm.dcFillerCount,
        productCount: this.topForm.dcProductCount
      }
      axios.post(DC_URL.RESEARCH + '/confirm', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.$refs.loadingModalRef.showModal(false)
            App.showModal({
              title: 'エラー',
              messages: [response.data.errorMessage],
              messageType: 'error',
              onOk: () => {
                this.$router.push('/mmstyle/research/input')
              }
            })
          } else {
            this.$refs.loadingModalRef.showModal(false)
            this.$router.push('/mmstyle/research/complete')
          }
        }).catch(error => {
          App.showModal({
            messages: ['アクセスが集中しており、通信に失敗いたしました。恐れ入りますが、もう一度お試しください。'],
            messageType: 'error',
            onOk: () => {
            }
          })
          console.log(error)
          this.$refs.loadingModalRef.showModal(false)
        })
    }
  },
  created () {
    this.fetchData()
    this.getViewDate()
    this.getViewTime()
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>
<style>
.note-size{
  font-size: 10px
}
</style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/BuildingResearchConfirm.vue